"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarOnEarth = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
class WarOnEarth {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.WAR_ON_EARTH;
        this.description = 'Reduce TR 4 steps. Each influence prevents 1 step.';
        this.revealedDelegate = PartyName_1.PartyName.MARS;
        this.currentDelegate = PartyName_1.PartyName.KELVINISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const steps = Math.max(0, 4 - turmoil.getPlayerInfluence(player));
            player.decreaseTerraformRatingSteps(steps, true);
        });
    }
}
exports.WarOnEarth = WarOnEarth;
//# sourceMappingURL=WarOnEarth.js.map